import request from '@/utils/request'

export function selectSuperwordCarvingSet(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/SuperwordCarvingSet/selectSuperwordCarvingSet?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDateSuperwordCarvingSet(data) {
    return request({
        url: `api/serviceCenter/SuperwordCarvingSet/upDateSuperwordCarvingSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteSuperwordCarving(data) {
    return request({
        url: `api/serviceCenter/SuperwordCarvingSet/bathDeleteSuperwordCarving`,
        method: 'post',
        data,
    })
}
